import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "mx-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-button"
}
const _hoisted_3 = { class: "text-body-1 font-weight-bold" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show) = $event)),
    fullscreen: "",
    transition: "dialog-bottom-transition",
    class: "dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "d-flex flex-column" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "ml-4 mt-6 text-h4" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Account Settings")
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, null, {
                  default: _withCtx(() => [
                    (_ctx.subscriptionActive)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                          _cache[4] || (_cache[4] = _createTextVNode("Current Plan:   ")),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.subscriptionLevel), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, "No Subscription")),
                    _createVNode(_component_v_btn, {
                      size: "medium",
                      variant: "text",
                      class: "ml-8",
                      href: "https://billing.stripe.com/p/login/bIYaI9awb43Oev64gg"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Manage")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_checkbox, {
                          label: "demo mode",
                          modelValue: _ctx.demoMode,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.demoMode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_list_item, { class: "mt-8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      onClick: _ctx.signOut
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("Sign Out")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, { class: "optionsBtns my-2" })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_tooltip, { location: "top" }, {
                activator: _withCtx(({ props: tooltip }) => [
                  _createVNode(_component_v_btn, _mergeProps(tooltip, {
                    size: "x-large",
                    color: "secondary",
                    variant: "text",
                    class: "text-h4 close-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false))
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-close")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "Close (esc)", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}